// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"1608":"dd1f68f318c537f37c37","2262":"0c35aca26179e194739a","3081":"7e5ac3d80e61ba0d6738"}[chunkId] + ".css";
};